import React from 'react'
import st from './AutoBotEditModal.module.scss'
import { forEachVariable } from './constants'

export const HighlightedOverlay = ({ text, availableVars }) => {
  const parts = []
  let last = 0

  forEachVariable(text, (name, token, index) => {
    if (index > last) parts.push(text.slice(last, index))
    const known = availableVars.includes(name)
    parts.push(
      <span key={`${index}-${token}`} className={known ? st.varOk : st.varBad}>
        {token}
      </span>,
    )
    last = index + token.length
  })
  parts.push(text.slice(last))

  return (
    <div className={st.overlayText} aria-hidden='true'>
      {parts}
      {'\u200b'}
    </div>
  )
}
